import React from 'react';
import { Handle, Position } from 'reactflow';
import { ZapOff } from 'lucide-react'; // Using the 'ZapOff' icon

const LoopBreakNode = ({ data }) => {
  const statusStyles = {
    idle: 'border-rose-500',
    pending: 'border-yellow-400',
    queued: 'border-blue-400',
    failed: 'border-red-500',
    success: 'border-green-500',
    running: 'animate-[pulse_1s_infinite] border-green-500',
    approvalNeeded: 'animate-[glow_1.5s_infinite] border-orange-500',
    diagnosing: 'animate-[pulse_1s_infinite] border-purple-500', // 👈 new line
  };

  // Default to 'idle' if status is not provided or invalid
  const status = data?.status || 'idle';

  return (
    <div
      className={`w-48 rounded-xl border-2 bg-zinc-900 shadow-lg ${statusStyles[status]}`}
    >
      <div className="flex items-center justify-center gap-3 p-3">
        <ZapOff className="text-rose-400" size={20} />
        <h3 className="text-lg font-bold text-white">Loop Break</h3>
      </div>
      {/* Handles for connections */}
      <Handle
        type="source"
        position={Position.Right}
        className="h-3 w-3 !bg-teal-500"
      />
      <Handle
        type="target"
        position={Position.Left}
        className="h-3 w-3 !bg-rose-500"
      />
    </div>
  );
};

export default LoopBreakNode;
